import React, {useState, useContext} from "react";
import {Btn, ContactMeWrapper, Form, HeadingFour, HeadingOne, TxtField, TxtFieldM} from "./ContactMeElements";
import {AppContext} from "../../AppContext";
import {ERROR, SUCCESS} from "../../services/notificationService/NotificationType";
import SendIcon from '@mui/icons-material/Send';


const ContactMe = () => {
    const [senderName, setSenderName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const {emailService, notificationService} = useContext(AppContext);



    const handleSubmit = (e) =>{

        e.preventDefault();
        emailService.sendEmail(senderName, email, message)
            //TODO replace by snack bar
            .then((response)=>{
                notificationService.addNotice("Message sent" ,SUCCESS);
            })
            // TODO replace by snack bar
            .catch((error)=>{
                //alert("Error sending message" + error.response.data);
                notificationService.addNotice("Error sending message" + error.response.data, ERROR);
            });
    }

    const handleChangeSenderName = (e) => {
        setSenderName(e.target.value);
    }


    const handleChangeEmail = (e) => {
        setEmail(e.target.value);
    }

    const handleChangeMessage = (e) => {
        setMessage(e.target.value);
    }

        return(

        <ContactMeWrapper>
            <div className="row" id='contactMe'>
                <HeadingOne>contact me</HeadingOne>
            </div>
            <div className="row">
                <HeadingFour >I'd love to hear from you!</HeadingFour>
            </div>
            <Form onSubmit={handleSubmit}>
                <TxtField id="filled-basic" value={senderName} onChange={handleChangeSenderName} required label="Name" variant="filled" placeholder="John Doe" />


                <TxtField id="filled-basic" type="email" onInput={handleChangeEmail} value={email} label="Email" variant="filled" placeholder="example@example.com" />

                <TxtFieldM label="Message" required multiline value={message} onChange={handleChangeMessage} variant="filled" />

                <Btn type="submit" color="primary" variant="contained" endIcon={<SendIcon />}>
                    Send
                </Btn>
                {/*<input type="submit" value="Submit" />*/}
            </Form>


        </ContactMeWrapper>


        )

}

export default ContactMe;
